<script lang="ts">
    export let firstName = '';
    export let lastName = '';
    export let email = '';
    export let imageUrl = '';
    export let size = 80;

    const COLORS = [
        '#056CF2',
        '#6366F1',
        '#8B5CF6',
        '#EC4899',
        '#F59E0B',
        '#10B981',
        '#14B8A6',
        '#F97316',
        '#EF4444',
        '#3B82F6',
        '#06B6D4',
        '#84CC16',
    ];

    $: initials = getInitials(firstName, lastName, email);
    $: bgColor = getColor(firstName, lastName, email);
    $: fontSize = Math.round(size * 0.38);

    function getInitials(first: string, last: string, mail: string): string {
        if (first && last) {
            return (first[0] + last[0]).toUpperCase();
        }
        if (first) return first[0].toUpperCase();
        if (mail) return mail[0].toUpperCase();
        return '?';
    }

    function getColor(first: string, last: string, mail: string): string {
        const str = (first || '') + (last || '') + (mail || '');
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return COLORS[Math.abs(hash) % COLORS.length];
    }
</script>

{#if imageUrl}
    <img
        src={imageUrl}
        alt="{firstName || 'User'} avatar"
        class="user-avatar"
        style="width: {size}px; height: {size}px;"
    />
{:else}
    <div
        class="user-avatar initials"
        style="width: {size}px; height: {size}px; background-color: {bgColor}; font-size: {fontSize}px;"
    >
        {initials}
    </div>
{/if}

<style>
    .user-avatar {
        border-radius: 50%;
        object-fit: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .user-avatar.initials {
        color: #fff;
        font-weight: 600;
        letter-spacing: 0.5px;
        user-select: none;
    }
</style>
